'use client';
import { FormControlProps } from './form-control.interfaces';
import { styled } from '@mui/material/styles';
import {
  FORM_CONTROL_BACKGROUND_COLORS,
  FORM_CONTROL_BORDER_COLORS,
  FORM_CONTROL_INPUT_PLACEHOLDER_COLORS,
  FORM_CONTROL_LABEL_FONT_WEIGHT,
  FORM_CONTROL_PADDING,
} from './form-control.constants';
import { getValueForPropColorOrDefault } from '../../utils/props.utils';
import { FormControl } from '@mui/material';

const BORDER_RADIUS = 15;

export const FormControlStyled = styled(FormControl)<FormControlProps>(({ theme, color, direction, size }) => ({
  '&.MuiFormControl-root': {
    flexDirection: direction ? direction : 'row',
    alignItems: direction && direction === 'column' ? 'unset' : 'center',
    backgroundColor: getValueForPropColorOrDefault(FORM_CONTROL_BACKGROUND_COLORS, color),
    border: `1px solid ${getValueForPropColorOrDefault(FORM_CONTROL_BORDER_COLORS, color)}`,
    borderRadius: `${BORDER_RADIUS}px`,
    padding: (size && FORM_CONTROL_PADDING[size]) || FORM_CONTROL_PADDING['medium'],
    '& .MuiInputBase-input::placeholder, & .MuiInputBase-input:focus::placeholder': {
      color: getValueForPropColorOrDefault(FORM_CONTROL_INPUT_PLACEHOLDER_COLORS, color),
    },
    '& label': {
      marginTop: direction && direction === 'column' && theme.spacing(1),
      fontWeight: getValueForPropColorOrDefault(FORM_CONTROL_LABEL_FONT_WEIGHT, color),
    },
  },
}));
